<script>
  /* global Global */
  export let value;

  const FIRST_BASE_MASK = 0b001;
  const SECOND_BASE_MASK = 0b010;
  const THIRD_BASE_MASK = 0b100;

  const projectStyle = Global.project.style;
</script>

<div class='live-bases' class:live-bases-old={projectStyle === 'old'}>
  <div class='live-bases-first'>
    <div class='live-bases-first-base' class:live-bases-first-base-active={value.bases & FIRST_BASE_MASK}/>
  </div>

  <div class='live-bases-second'>
    <div class='live-bases-second-base' class:live-bases-second-base-active={value.bases & SECOND_BASE_MASK}/>
  </div>

  <div class='live-bases-third'>
    <div class='live-bases-third-base' class:live-bases-third-base-active={value.bases & THIRD_BASE_MASK}/>
  </div>
</div>

<style>
  .live-bases {
    position: relative;

    width: 80px;
    height: 60px;
  }

  .live-bases-first, .live-bases-second, .live-bases-third {
    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 0px;
    height: 0px;
  }

  .live-bases-first-base,
  .live-bases-second-base,
  .live-bases-third-base {
    flex-shrink: 0;

    width: calc(20px * var(--sqrt-2) - 5px);
    height: calc(20px * var(--sqrt-2) - 5px);

    margin: 2.5px;

    border-radius: 2px;

    background: var(--grey-3);

    transform: rotate(45deg);
  }

  .live-bases-first-base-active,
  .live-bases-second-base-active,
  .live-bases-third-base-active {
    background: linear-gradient(90deg, var(--yellow), var(--orange));
  }

  .live-bases-old .live-bases-first-base-active,
  .live-bases-old .live-bases-second-base-active,
  .live-bases-old .live-bases-third-base-active {
    background: var(--yellow);
  }

  .live-bases-first {
    top: 40px;
    right: 20px;
  }

  .live-bases-second {
    top: 20px;
    right: 40px;
  }

  .live-bases-third {
    top: 40px;
    right: 60px;
  }

  :global(body.dark) .live-bases-first-base,
  :global(body.dark) .live-bases-second-base,
  :global(body.dark) .live-bases-third-base {
    background: var(--grey-7);
  }

  :global(body.dark) .live-bases-first-base-active,
  :global(body.dark) .live-bases-second-base-active,
  :global(body.dark) .live-bases-third-base-active {
    background: linear-gradient(90deg, var(--yellow-dark), var(--orange-dark));
  }

  :global(body.dark) .live-bases-old .live-bases-first-base-active,
  :global(body.dark) .live-bases-old .live-bases-second-base-active,
  :global(body.dark) .live-bases-old .live-bases-third-base-active {
    background: var(--yellow-dark);
  }
</style>
